import { create } from "zustand";

// TODO: Save section completion to the server when that API is ready
// Intro/outro pages have no server-side progress yet, so we remember which ones
// the user has finished (clicked the CTA) in localStorage. Keyed by kind +
// owning module/chapter node id, since a node can have both an intro and outro.
const STORAGE_KEY = "ilp.completedSections";

export type SectionKind = "intro" | "outro";

export const sectionKey = (kind: SectionKind, nodeId: string) =>
  `${kind}:${nodeId}`;

const loadCompleted = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
};

const persist = (ids: Set<string>) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    // localStorage unavailable (private mode / quota) — fail silently.
  }
};

interface SectionCompletionState {
  completed: Set<string>;
  markCompleted: (key: string) => void;
}

export const useSectionCompletionStore = create<SectionCompletionState>(
  (set) => ({
    completed: new Set(loadCompleted()),
    markCompleted: (key) =>
      set((state) => {
        if (state.completed.has(key)) return state;
        const next = new Set(state.completed);
        next.add(key);
        persist(next);
        return { completed: next };
      }),
  })
);
